import MUIMenu from '@material-ui/core/Menu';
import styled, { keyframes, css } from 'styled-components';
import PropTypes from 'prop-types';
import boxShadowGenerator from '@utils/boxShadowGenerator';

const keyFrameOpen = keyframes`
  0% {
    max-height: 0px;
  }
  50% {
    max-height: 276px;
    padding-bottom: 20px;
  }
  100% {
    padding-bottom: 0px;
  }
`;

const keyFrameClose = keyframes`
  0% {
    padding-bottom: 20px;
    max-height: 276px;
  }

  100% {
    padding-bottom: 0px;
    max-height: 0px;
  }
`;

const animationOpen = () =>
  css`
    ${keyFrameOpen} 300ms ease-in 0s
  `;

const animationClose = () =>
  css`
    ${keyFrameClose} 300ms ease-out 0s
  `;

const StyledMenu = styled(MUIMenu)`
  &.MuiPopover-root .MuiPaper-root {
    width: ${({ width }) => width};
    border: ${({ theme, $noBorder }) =>
      $noBorder ? 'none' : `1px solid ${theme.colors.dropShadow}`};
    border-radius: 8px;
    margin-top: 10px;
    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: ${({ theme }) => boxShadowGenerator({ theme })};
    transform: none !important;
    opacity: 1 !important;
    animation: ${({ open }) => (open ? animationOpen : animationClose)};
    max-height: ${({ height }) => height};
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none; /* Firefox */
    /* Chrome and IOS Safari */
    ::-webkit-scrollbar {
      width: 0px;
      background: transparent;
    }
  }
  &.MuiPopover-root .MuiMenu-list {
    padding-top: ${({ $noPadding }) => ($noPadding ? '0px' : '8px')};
    padding-bottom: ${({ $noPadding }) => ($noPadding ? '0px' : '8px')};
  }
`;

const Menu = ({
  children,
  anchorEl,
  onClose,
  position,
  width,
  height,
  noPadding,
  noBorder,
  anchorOrigin,
  transformOrigin
}) => {
  return (
    <StyledMenu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={
        anchorOrigin || {
          vertical: 'bottom',
          horizontal: position
        }
      }
      transformOrigin={
        transformOrigin || {
          vertical: 'top',
          horizontal: position
        }
      }
      variant="menu"
      transitionDuration={200}
      width={width}
      height={height}
      $noPadding={noPadding}
      $noBorder={noBorder}
    >
      {children}
    </StyledMenu>
  );
};

Menu.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  anchorOrigin: PropTypes.objectOf(PropTypes.any),
  transformOrigin: PropTypes.objectOf(PropTypes.any),
  position: PropTypes.oneOf(['left', 'center', 'right']),
  width: PropTypes.string,
  height: PropTypes.string,
  noPadding: PropTypes.bool,
  noBorder: PropTypes.bool,
  anchorEl: PropTypes.node
};

Menu.defaultProps = {
  anchorOrigin: null,
  transformOrigin: null,
  position: 'left',
  width: 'auto',
  height: '276px',
  noPadding: false,
  noBorder: false,
  anchorEl: null
};

export default Menu;
